export const FareCalculator = (distance, time, rateDetails, instructionData, decimal) => {

    let rate = parseFloat(rateDetails.rate_per_unit_distance) || 0;
    let rateHour = parseFloat(rateDetails.rate_per_hour) || 0;
    let baseFare = parseFloat(rateDetails.base_fare) || 0;
    let minFare = parseFloat(rateDetails.min_fare) || 0;
    let convFees = parseFloat(rateDetails.convenience_fees) || 0;
    let dec = parseInt(decimal) || 2;

    let baseCalculated = (rate * (parseFloat(distance) || 0)) + (rateHour * ((parseFloat(time) || 0) / 3600));
    if (baseFare > 0) {
        baseCalculated = baseCalculated + baseFare;
    }
    if (instructionData && instructionData.parcelTypeSelected) {
        baseCalculated = baseCalculated + (parseFloat(instructionData.parcelTypeSelected.amount) || 0);
    }
    if (instructionData && instructionData.optionSelected) {
        baseCalculated = baseCalculated + (parseFloat(instructionData.optionSelected.amount) || 0);
    }
    let total = baseCalculated > minFare ? baseCalculated : minFare;
    let convenienceFee = 0;
    if (rateDetails.convenience_fee_type && rateDetails.convenience_fee_type == 'flat') {
        convenienceFee = convFees;
    } else {
        convenienceFee = (total * convFees / 100);
    }
    let grand = total + convenienceFee;

    return {
        totalCost: parseFloat(total.toFixed(dec)),
        grandTotal: parseFloat(grand.toFixed(dec)),
        convenience_fees: parseFloat(convenienceFee.toFixed(dec))
    }

}
